import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import { environment } from '../../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
    ICheckbox,
    IColumnchooser,
    IColumnHiding,
    IColumns,
    IEditing,
    IExportExcel,
    IGridOptions,
    IScroll,
    ISearchPanel,
    Toolbar,
} from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import { AppState, selectOperacionState, selectUtilsState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { CargaMasivaComponent as ok } from 'app/utilerias/carga-masiva/carga-masiva.component';
import { NuevaCargaMasivaComponent } from 'app/utilerias/nueva-carga-masiva/nueva-carga-masiva.component';

@Component({
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.scss']
})
export class CargaMasivaComponent implements OnInit {
    data: any;
    spinner: boolean = false;
    getStateOperacion: Observable<any>;
    subscribeOperacion: any;
    idOperacion: number;
    // Grid variables
    gridOptions: IGridOptions;
    columns: IColumns[];
    exportExcel: IExportExcel;
    searchPanel: ISearchPanel;
    scroll: IScroll;
    toolbar: Toolbar[];
    columnHiding: IColumnHiding;
    Checkbox: ICheckbox;
    Editing: IEditing;
    Columnchooser: IColumnchooser;
    objetoGridConfiguration: any;
    objetosSelected: any;
    verGrid: boolean = false;
    btnRefrescar: any;
    lstDataReport = [];
    dataReport = [];
    idTipoReporteSel: number = 1;
    ocultarGrid: boolean = false;
    nombreReporte: string = '';
    datosevent: any;
    idEmpresa: any;
    configured: boolean = null;

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        private _snackBar: MatSnackBar
    ) {

    }

    ngOnInit(): void {
        this.getStateOperacion = this.store.select(selectOperacionState);
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (state.empresaSeleccionada === undefined) {
				this.configured = false;
				throw new Error('Empresa no configurada. Proceso interrumpido.');
			}
			else {
				this.configured = true;
                if(this.idEmpresa !== state.empresaSeleccionada.id){
                    this.idEmpresa = state.empresaSeleccionada.id;
                    this.GetArchivosCarga();
                    this.ocultarGrid = false;
                }
            }
        });
    }

    GetArchivosCarga() {
        this.store.dispatch(MostrarSpinner());

        this.verGrid = false;
        this.dataReport.length = 0;
        this.lstDataReport.length = 0;
        this.srvcoal
        .getService(
            `ope-empresas?filters[id]=${this.idEmpresa}&fields[0]=id&populate=tar_tareas.cat_tarea_tipo,tar_tareas.cat_tarea_estatus,tar_tareas.archivoOriginal,tar_tareas.archivoProcesado`
        )
            .subscribe(
                (res: any) => {
                    //this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                        console.log('erro *************** 1');
                    }  else {
                        this.dataReport = res.data[0].attributes.tar_tareas.data;
                        this.ObjectGrid();
                    }
                },
                (error: any) => {
                    console.log('erro *************** 3', error);
                    // this.store.dispatch(OcultarSpinner());
                }
            );
    }

    ObjectGrid() {
        this.nombreReporte = 'Carga masiva';
        this.objetoGridConfiguration = {
            GridOptions: {
                paginacion: 20,
                pageSize: ['40', '60', '80', '100'],
            },
            ExportExcel: { enabled: false, fileName: 'Historico' },
            ColumnHiding: { hide: true },
            Checkbox: { checkboxmode: 'single' },
            Editing: { allowupdate: true, mode: 'cell' },
            Columnchooser: { columnchooser: true },
            SearchPanel: {
                visible: true,
                width: 200,
                placeholder: 'Buscar...',
                filterRow: true,
            },
            Scroll: { mode: 'infinite' },
            Color: null,
            Detail: { detail: true },
            ToolbarDetail: null,
            ToolBox: [
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 60,
                        onClick: this.descargarArchivoSalida.bind(this),
                        icon: '../../../assets/icons/ver.png',
                    },
                    visible: true,
                    name: 'simple',
                },
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    // options: {
                    //     width: 60,
                    //     icon: '../../../assets/icons/borrar.png',
                    //     onClick: this.eliminar.bind(this),
                    // },
                    visible: true,
                    name: 'simple',
                },
            ],
            Columns: [],
            Data: [],
            Columns1: [1],
            Data1: [],
            datosMessage(evento) {
                this.objetosSelected = evento.data;
            },
        };
        this.DataColumnsGrid();
    }

    DataColumnsGrid() {
        if (
            !this.lstDataReport.find(
                (x) => x.idTipoReporte === this.idTipoReporteSel
            )
        ) {
            let columnsMulti = [];
            columnsMulti.push({
                caption: '#',
                dataField: 'id',
                allowEditing: false,
                sortOrder: 'desc'
            });
            columnsMulti.push({
                caption: 'Tipo',
                dataField: 'attributes.cat_tarea_tipo.data.attributes.tipo',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Nombre archivo',
                dataField: 'attributes.archivoOriginal.data.attributes.name',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Estatus',
                dataField:
                    'attributes.cat_tarea_estatus.data.attributes.estatus',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Registros procesados',
                dataField: 'attributes.registrosProcesados',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Registros total',
                dataField: 'attributes.registrosTotal',
                allowEditing: false,
            });
            columnsMulti.push({
                caption: 'Inicio',
                dataField: 'attributes.fechaInicio',
                allowEditing: false,
                fixed: true,
            });
            columnsMulti.push({
                caption: 'Fin',
                dataField: 'attributes.fechaFin',
                allowEditing: false,
                fixed: true,
            });
            setTimeout(
                () =>
                    this.lstDataReport.push({
                        idTipoReporte: this.idTipoReporteSel,
                        columnas: columnsMulti,
                        dataReport: this.dataReport,
                        identificadorGrid: 0,
                    }),
                500
            );
            setTimeout(() => this.FillGrid(), 800);
        } else {
            this.FillGrid();
        }
    }

    FillGrid() {
        this.objetoGridConfiguration.Columns = this.lstDataReport.find(
            (x) =>
                x.idTipoReporte === this.idTipoReporteSel &&
                x.identificadorGrid === 0
        ).columnas;
        this.objetoGridConfiguration.Data = this.lstDataReport.find(
            (x) =>
                x.idTipoReporte === this.idTipoReporteSel &&
                x.identificadorGrid === 0
        ).dataReport;

        this.objetoGridConfiguration.Data.sort((a, b) => b.id - a.id);
        this.verGrid = true;
        this.store.dispatch(OcultarSpinner());
    }
    openDialogNuevaCarga(): void {
        const dialogRef = this.dialog.open(NuevaCargaMasivaComponent, {
            width: '800px',
            data: null,
            disableClose: false,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.success == 1) {
                this.GetArchivosCarga();
            }
        });
    }

    descargarArchivoSalida($event) {
        let fileOutput = this.datosevent.attributes.archivoProcesado.data.attributes;
        FileSaver.saveAs(environment.hostBack + fileOutput.url, fileOutput.name);
    }

    datosMessage($event) {
        try {
            this.datosevent = $event.data[0];
        } catch (error) {
            // this.Excepciones(error, 1);
        }
    }
    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: this.idOperacion,
                    idAplicacion: 1,
                    moduloExcepcion: 'app-carga-masiva',
                    mensajeExcepcion: '',
                    stack: pila,
                },
            });
            dialogRef.afterClosed().subscribe((result: any) => {});
        } catch (error) {
            // console.error(error);
        }
    }
}
